var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.3521 24.8192L24.9929 4.27916C23.4666 1.51554 21.3545 0 19.0294 0C16.7043 0 14.5923 1.51554 13.0659 4.27916L1.70676 24.8192C0.269124 27.4401 0.109387 29.9542 1.26305 31.9333C2.41671 33.9124 4.68853 35 7.6703 35H30.3885C33.3703 35 35.6421 33.9124 36.7958 31.9333C37.9494 29.9542 37.7897 27.4223 36.3521 24.8192Z",
    fill: "#FF3667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0323 22.7378C18.3046 22.7378 17.7012 22.1316 17.7012 21.4006V12.4857C17.7012 11.7547 18.3046 11.1484 19.0323 11.1484C19.76 11.1484 20.3635 11.7547 20.3635 12.4857V21.4006C20.3635 22.1316 19.76 22.7378 19.0323 22.7378Z",
    fill: "#FF3667"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0385 28.5392C18.932 28.5392 18.8078 28.5213 18.6836 28.5035C18.5771 28.4857 18.4706 28.45 18.3641 28.3965C18.2576 28.3609 18.1511 28.3074 18.0446 28.2361C17.9559 28.1647 17.8671 28.0934 17.7784 28.0221C17.4589 27.6833 17.2637 27.2198 17.2637 26.7562C17.2637 26.2926 17.4589 25.829 17.7784 25.4903C17.8671 25.419 17.9559 25.3476 18.0446 25.2763C18.1511 25.205 18.2576 25.1515 18.3641 25.1158C18.4706 25.0624 18.5771 25.0267 18.6836 25.0089C18.9143 24.9554 19.1628 24.9554 19.3758 25.0089C19.5 25.0267 19.6065 25.0624 19.713 25.1158C19.8195 25.1515 19.926 25.205 20.0325 25.2763C20.1212 25.3476 20.2099 25.419 20.2987 25.4903C20.6182 25.829 20.8134 26.2926 20.8134 26.7562C20.8134 27.2198 20.6182 27.6833 20.2987 28.0221C20.2099 28.0934 20.1212 28.1647 20.0325 28.2361C19.926 28.3074 19.8195 28.3609 19.713 28.3965C19.6065 28.45 19.5 28.4857 19.3758 28.5035C19.2693 28.5213 19.145 28.5392 19.0385 28.5392Z",
    fill: "#FF3667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.0b45f87722e892a589e4878e68759e0e.svg";
export { ForwardRef as ReactComponent };